import type {
  AppConfigPublishResult,
  LLMConfigRollbackRequest,
  LLMConfigValidation,
  PricingCatalogPublishRequest,
  PricingCatalogView,
} from '@/types';
import api from './api';

export const llmPricingApi = {
  getPricingCatalog: async (): Promise<PricingCatalogView> => {
    return api.get('/api/v1/app-config/pricing-catalog');
  },

  publishPricingCatalog: async (
    data: PricingCatalogPublishRequest,
  ): Promise<AppConfigPublishResult> => {
    return api.post('/api/v1/app-config/pricing-catalog', data);
  },

  validatePricingCatalog: async (
    document: PricingCatalogView['document'],
  ): Promise<LLMConfigValidation> => {
    return api.post('/api/v1/app-config/pricing-catalog/validate', {
      document,
    });
  },

  rollbackPricingCatalog: async (
    payload: LLMConfigRollbackRequest,
  ): Promise<AppConfigPublishResult> => {
    return api.post('/api/v1/app-config/pricing-catalog/rollback', payload);
  },
};
